import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {ComisionServices} from '../services/comision.services';
import {forkJoin} from 'rxjs';
import {EmpleadoComisionesModel} from '../models/empleado.comisiones.model';
import {CargoServices} from '../../CoreModule/services/cargo.services';
import {CargoEntity} from '../../CoreModule/entities/cargo.entity';
import {ComisionModel} from '../models/comision.model';
import {NgxSpinnerService} from 'ngx-spinner';

import * as moment from 'moment';
import * as lodash from 'lodash';
import {ActivatedRoute} from '@angular/router';
import {getLoginUser, getLoginUserFull, UsuarioServices} from '../../CoreModule/services/usuario.services';
import {ExcelServices} from '../../CoreModule/services/excel.services';
import {UsuarioEntity} from '../../CoreModule/entities/usuario.entity';
import {ReporteServices} from '../../ReportesModule/services/reporte.services';
import {forEach} from 'async';
import {PERMISOS} from '../../variables';
import {BsModalService, TypeaheadMatch} from 'ngx-bootstrap';

@Component({
  selector: 'comision',
  templateUrl: '../templates/comision.template.html',
  styleUrls: ['../styles/comision.styles.scss']
})
export class ComisionComponent implements OnInit {

  tiendas: TiendaEntity[] = [];
  semIni: number = 0;
  semFinal: number = 0;
  ano: string = '';

  listaEmpleados: string[] = [];
  lstEmpleadoComisiones: EmpleadoComisionesModel[] = [];
  cargo: CargoEntity;

  constructor(private ts: TiendaServices, private cs: ComisionServices, private cars: CargoServices) {
  }

  ngOnInit(): void {
    this.ts.getAllTiendas().subscribe((d: any) => {

      this.tiendas = d.data.tiendas;
    });

    this.cars.getCargo('5c8138c951aaceac140d3f0b').subscribe((d: any) => {
      // console.log(d);
      this.cargo = d.data.cargo;
    });
  }

  consultarComision() {
    this.listaEmpleados = [];
    this.lstEmpleadoComisiones = [];
    this.cs.getListEmpleados(this.semIni, this.semFinal, this.ano).subscribe((d: any) => {
      // console.log(d);
      this.listaEmpleados = d.data.listaIdsEmpleadoSemana;

      let consultas: any[] = [];

      // this.listaEmpleados = this.listaEmpleados.slice(0, 30);

      for (let e of this.listaEmpleados) {
        consultas.push(this.cs.getInfoEmpleado(e, this.semIni, this.semFinal, this.ano));
      }

      forkJoin(consultas).subscribe((d: any) => {

        for (let ec of d) {

          let data = ec.data.infoMetaEmpleado;

          if (data) {
            let empleCom = new EmpleadoComisionesModel();
            empleCom.mallas = data.mallas;
            empleCom.empleado = data.empleado;
            empleCom.cargo = this.cargo;
            //empleCom.calcularComision(data.ventas, this.tiendas);
            this.lstEmpleadoComisiones.push(empleCom);
          }
        }

      });


    });

  }

}

@Component({
  selector: 'lista-comisiones',
  templateUrl: '../templates/lista.comisiones.template.html'
})
export class ListaComisionesComponent implements OnInit {
  public lstComisiones: ComisionModel[] = [];

  permisos: any = {
    LIQUIDARCOMISION: 0,
    ADMINCOMISION: 0,
  };

  user: any;

  constructor(private cs: ComisionServices, private spinner: NgxSpinnerService, private us: UsuarioServices) {
  }

  ngOnInit(): void {
    this.spinner.show();

    this.us.getUser(getLoginUser()).subscribe(d => {
      this.user = d.data.usuario;
      this.ngComprobarPermisos();
    });

    this.cs.getAllComisiones().subscribe((d: any) => {
      this.spinner.hide();

      this.lstComisiones = d.data.comisiones;
    });
  }

  ngComprobarPermisos() {

    this.user.rol.permisos.map(p => {
      if (p.id == PERMISOS.LIQUIDARCOMISIONES)
        this.permisos.LIQUIDARCOMISION = 1;

      if (p.id == PERMISOS.ADMINCOMISIONES)
        this.permisos.ADMINCOMISION = 1;

    });

  }

  eliminarComision(comision: any) {

    if (confirm(`Desea eliminar la comision ${comision.nombre}`)) {

      this.spinner.show();


      this.cs.eliminarComision(comision._id).subscribe((d: any) => {

        this.spinner.hide();
        if (d.data.eliminarComision == 1)
          this.lstComisiones = this.lstComisiones.filter(c => c._id != comision._id);
      });
    }
  }

}

@Component({
  selector: 'new-comision',
  templateUrl: '../templates/new.comision.template.html'
})
export class NewComisionesComponent implements OnInit {

  tiendas: TiendaEntity[] = [];

  comision: ComisionModel = new ComisionModel();

  listaEmpleados: string[] = [];
  lstEmpleadoComisiones: EmpleadoComisionesModel[] = [];
  cargo: CargoEntity;

  comisionBlanco: boolean = false;


  constructor(private cs: ComisionServices, private ts: TiendaServices, private cars: CargoServices, private spinner: NgxSpinnerService, private reps: ReporteServices) {
  }

  ngOnInit(): void {
    this.spinner.show();

    forkJoin([this.ts.getAllTiendas(), this.cars.getCargo('5cbb7d63ff4e15868c9d19ba')]).subscribe((d: any) => {
      this.tiendas = d[0].data.tiendas;
      this.cargo = d[1].data.cargo;

      this.spinner.hide();
    });

  }

  consultarComision() {
    this.spinner.show();
    this.lstEmpleadoComisiones = [];
    this.listaEmpleados = [];
    let fecha1 = moment(this.comision.fechaInicio).seconds(0).millisecond(0);
    let fecha2 = moment(this.comision.fechaFin).seconds(0).millisecond(0);


    this.cs.getListEmpleadosCalendario(fecha1.format('DD-MM-YYYY'), fecha2.format('DD-MM-YYYY')).subscribe((d: any) => {
      this.listaEmpleados = d.data.listaIdEmpleadosCalendario;

      // con fines de depuracion para hacer mas corta la consulta
      // this.listaEmpleados = this.listaEmpleados.slice(0, 10);

      // console.log(this.listaEmpleados);
      // return;

      let consultas: any[] = [];

      if (!this.comisionBlanco) {
        for (let e of this.listaEmpleados) {
          consultas.push(this.cs.getInfoEmpleadoCalendario(e, fecha1.format('DD-MM-YYYY'), fecha2.format('DD-MM-YYYY')));
        }

        // consultas.push(this.cs.getInfoEmpleadoCalendario("7998", fecha1.format('DD-MM-YYYY'), fecha2.format('DD-MM-YYYY')));

        forkJoin(consultas).subscribe((d: any) => {

          for (let ec of d) {
            let data = ec.data.infoMetaEmpleadoCalendario;


            if (data) {
              let empleCom = new EmpleadoComisionesModel();
              empleCom.mallas = data.mallas;
              empleCom.empleado = data.empleado;
              empleCom.pptoTienda = data.pptoTienda;
              empleCom.ventasTienda = data.ventasTienda;
              empleCom.fechaInicio = this.comision.fechaInicio;
              empleCom.fechaFin = this.comision.fechaFin;
              empleCom.tiendaMaestra = data.tiendaMaestra;


              if (data.cargo)
                empleCom.cargo = data.cargo;
              else
                empleCom.cargo = this.cargo;


              empleCom.calcularComision(data.ventas, this.tiendas, fecha1, fecha2);
              // empleCom.tiendaMaestra = empleCom.tiendas[empleCom.tiendas.length - 1].idDB;
              // console.log(empleCom);
              // empleCom.tiendaMaestra = empleCom.buscarTiendaMaestra();

              // console.log(empleCom);
              this.lstEmpleadoComisiones.push(empleCom);
            }
          }
          this.spinner.hide();
          this.guardarComision();
        });
      } else {
        this.spinner.hide();
        this.guardarComision();
      }
    });


  }

  guardarComision() {
    this.spinner.show();

    this.cs.newComision(this.comision).subscribe((d: any) => {

      if (!this.comisionBlanco) {
        let consultas: any[] = [];
        for (let ec of this.lstEmpleadoComisiones) {

          consultas.push(this.cs.addEmpleComision(d.data.addComision, ec));
        }

        forkJoin(consultas).subscribe(d => {

          this.spinner.hide();
          alert('comision creada con exito');
        });
      } else {
        this.spinner.hide();
      }

    });
  }


}


@Component({
  selector: 'new-comision-tienda',
  templateUrl: '../templates/new.comision.tienda.template.html'
})
export class NewComisionTiendaComponent implements OnInit {

  tiendas: TiendaEntity[] = [];

  tiendaSelec: TiendaEntity;

  comision: ComisionModel;
  comisiones: ComisionModel[] = [];

  listaEmpleados: string[] = [];
  lstEmpleadoComisiones: EmpleadoComisionesModel[] = [];
  cargo: CargoEntity;

  cSelectName: string = '';
  tSelectName: string = '';

  constructor(private cs: ComisionServices, private ts: TiendaServices, private cars: CargoServices, private spinner: NgxSpinnerService, private reps: ReporteServices) {
  }

  ngOnInit(): void {
    this.spinner.show();
    forkJoin([this.ts.getAllTiendas(), this.cars.getCargo('5cbb7d63ff4e15868c9d19ba'), this.cs.getAllComisiones()]).subscribe((d: any) => {
      // console.log(d);
      this.tiendas = d[0].data.tiendas;
      this.cargo = d[1].data.cargo;

      this.comisiones = d[2].data.comisiones;

      this.spinner.hide();
    });
  }

  consultarComision() {

    if (this.tiendaSelec == undefined)
      return;

    if (this.comision == undefined)
      return;
    ;

    this.spinner.show();
    this.lstEmpleadoComisiones = [];
    this.listaEmpleados = [];
    let fecha1 = moment(this.comision.fechaInicio).seconds(0).millisecond(0);
    let fecha2 = moment(this.comision.fechaFin).seconds(0).millisecond(0);

    this.cs.getListEmpleadosCalendarioXTienda(fecha1.format('DD-MM-YYYY'), fecha2.format('DD-MM-YYYY'), this.tiendaSelec.idDB).subscribe((d: any) => {

      // console.log(d);
      this.listaEmpleados = d.data.listaIdEmpledosCalendarioxTienda;

      let consultas: any[] = [];

      for (let e of this.listaEmpleados) {
        consultas.push(this.cs.getInfoEmpleadoCalendario(e, fecha1.format('DD-MM-YYYY'), fecha2.format('DD-MM-YYYY')));
      }

      forkJoin(consultas).subscribe((d2: any) => {


        // console.log(d2);


        for (let ec of d2) {
          let data = ec.data.infoMetaEmpleadoCalendario;


          if (data) {
            let empleCom = new EmpleadoComisionesModel();
            empleCom.mallas = data.mallas;
            empleCom.empleado = data.empleado;
            empleCom.pptoTienda = data.pptoTienda;
            empleCom.ventasTienda = data.ventasTienda;
            empleCom.fechaInicio = this.comision.fechaInicio;
            empleCom.fechaFin = this.comision.fechaFin;
            empleCom.tiendaMaestra = data.tiendaMaestra;


            if (data.cargo)
              empleCom.cargo = data.cargo;
            else
              empleCom.cargo = this.cargo;

            empleCom.calcularComision(data.ventas, this.tiendas, fecha1, fecha2);
            // empleCom.tiendaMaestra = empleCom.tiendas[empleCom.tiendas.length - 1].idDB;
            // empleCom.tiendaMaestra = empleCom.buscarTiendaMaestra();

            this.lstEmpleadoComisiones.push(empleCom);
          }
        }
        this.spinner.hide();

        this.guardarComision();
      });
    });
  }

  comisionSelect(event: TypeaheadMatch) {

    this.comision = event.item;
  }

  tiendaSelected(event: TypeaheadMatch) {

    this.tiendaSelec = event.item;
  }


  guardarComision() {

    this.spinner.show();


    let consultas: any[] = [];
    for (let ec of this.lstEmpleadoComisiones) {

      consultas.push(this.cs.addEmpleComision(this.comision._id, ec));
    }

    forkJoin(consultas).subscribe(d => {

      this.spinner.hide();
      alert('comision actualizada con exito');
    });


  }
}

@Component({
  selector: 'view-comision',
  templateUrl: '../templates/view.comision.template.html',
  styleUrls: ['../styles/comision.styles.scss']
})
export class ViewComisionesComponent implements OnInit {

  comision: ComisionModel;
  lstEmpleados: EmpleadoComisionesModel[] = [];
  tempListEmple: EmpleadoComisionesModel[] = [];
  rows: any[] = [];
  tempRows: any[] = [];
  public tempFullRows: any[] = [];
  public fecha1: any;
  public fecha2: any;
  public usuarioAprueba = '';
  public filtro: string;

  totalDias: number = 0;


  getRowClass = (row) => {

    let diasInc = (row.dias.totCat.diasProgramados + row.dias.totCat.diasCompensados) !== this.totalDias;
    let retirado = (row.dias.empleado.estado && row.dias.empleado.estado == 'RETIRADO');


    if (retirado)
      diasInc = false;
    return {
      'diasInc': diasInc,
      'colReti': retirado
    };
  };


  @ViewChild('myTable', {static: true})
  table: any;

  columns = [
    {name: 'codigo'},
    {name: 'Tienda'},
    {name: 'Nombre'},
    {name: 'Cargo'},
    {name: 'Cantidad Mallas'},
    {name: 'Ventas'},
    {name: 'Meta'},
    {name: 'Cumplimiento'},
    {name: 'Valor'},
    {name: 'Dias'},
    {name: 'Aprobado'},
    {name: 'Observacion'},
    {name: 'Liquidado'}
  ];

  constructor(private cs: ComisionServices, private activeRouter: ActivatedRoute, private spinner: NgxSpinnerService, private exs: ExcelServices) {
  }

  ngOnInit(): void {
    let id = this.activeRouter.snapshot.params.id;

    this.usuarioAprueba = getLoginUserFull().nombres;

    this.spinner.show();

    this.cs.getComision(id).subscribe((d: any) => {

      this.comision = d.data.comision;

      this.fecha1 = moment(this.comision.fechaInicio, 'YYYY-MM-DD');
      this.fecha2 = moment(this.comision.fechaFin, 'YYYY-MM-DD');
      this.totalDias = this.fecha2.diff(this.fecha1, 'd') + 1;
      this.cs.getEmpleadoComision(id, getLoginUser()).subscribe((d2: any) => {


        for (let de of d2.data.empleadoComision) {

          let nec: EmpleadoComisionesModel = new EmpleadoComisionesModel();

          nec.crearEmpleadoComisionModel(de);
          nec.tempObs = (nec.observaciones.length > 0) ? nec.observaciones[0] : '';

          this.lstEmpleados.push(nec);
          this.tempListEmple.push(nec);


        }

        this.ordenarLista();

        // console.log(this.lstEmpleados[0]);
        this.lstEmpleados.map((e) => {

          let tFound = e.tiendas.find(_t => _t.idDB == e.tiendaMaestra);

          if (!tFound)
            tFound = this.devolverTiendaMayorVenta(e.ventas, e.tiendas);


          this.rows.push({
            codigo: e.empleado,
            // tienda: (tFound) ? tFound.nombre : e.tiendas[e.tiendas.length - 1].nombre,
            tienda: tFound.nombre,
            nombre: e.empleado.nombre,
            cargo: e.cargo,
            cantidadMallas: e.mallas.length,
            ventas: e,
            meta: e,
            cumplimiento: e,
            valor: e,
            dias: e,
            aprobado: e,
            observacion: e,
            liquidado: e,
            detalle: e
          });
        });


        this.rows = [...this.rows];
        this.tempRows = [...this.rows];

        this.spinner.hide();
      });
    });


  }

  ordenarLista() {
    this.lstEmpleados.sort((a, b) => {
      let tiendaA = a.tiendas[a.tiendas.length - 1];
      let tiendaB = b.tiendas[b.tiendas.length - 1];

      if (tiendaA.nombre > tiendaB.nombre)
        return 1;
      if (tiendaA.nombre < tiendaB.nombre)
        return -1;

      return 0;
    });
  }

  toggleExpandRow(row) {

    this.table.rowDetail.toggleExpandRow(row);
  }

  toggleExpandGroup(group) {
    // console.log(group);
    this.table.groupHeader.toggleExpandGroup(group);
  }

  filtrarEmpleado(event) {
    let val = event.target.value.toLowerCase();
    const temp = this.tempRows.filter(e => {
      return e.nombre.toLowerCase().indexOf(val) !== -1 || !val;
    });

    this.rows = [...temp];
  }

  filtrarTienda(event) {
    let val = event.target.value.toLowerCase();
    const temp = this.tempRows.filter(e => {
      return e.tienda.toLowerCase().indexOf(val) !== -1 || !val;
    });

    this.rows = [...temp];
  }

  filtrarCedula(event) {
    let val = event.target.value.toLowerCase();
    const temp = this.tempRows.filter(e => {
      return e.empleado.doc.toLowerCase().indexOf(val) !== -1 || !val;
    });

    this.rows = [...temp];
  }

  filtrarMayorCant(event) {
    let val = +event.target.value;
    const temp = this.tempListEmple.filter(e => {
      return e.mallas.length > val || !val;
    });
    this.lstEmpleados = temp;
  }

  autorizarComision(e: EmpleadoComisionesModel) {

    e.usuarioAprueba.push(this.usuarioAprueba);
    e.observaciones.push('Sin novedad');

    this.cs.aprobarComision(e._id, this.usuarioAprueba, e.aprobado, e.observaciones, e.fechaObs).subscribe((d) => {
      // console.log(d);
    });
  }

  exportarComision() {
    let data: any[] = [];

    for (let e of this.lstEmpleados) {
      // if(e.empleado.doc.toString().trim() == '1074417849') {
      //   console.log(e);
      //   this.devolverTiendaMayorVenta(e.ventas, e.tiendas);
      // }
      let tFound = e.tiendas.find(_t => _t.idDB == e.tiendaMaestra);

      if(!tFound)
        tFound = this.devolverTiendaMayorVenta(e.ventas, e.tiendas);

      if (e.mallas.length > 0) {
        let de = {
          id: e.empleado.doc.toString().trim(),
          nombre: e.empleado.nombre,
          cargo: e.cargo.nombre,
          // tienda: (tFound) ? tFound.nombre : e.tiendas[e.tiendas.length - 1].nombre,
          tienda: tFound.nombre,
          // co: e.tiendas[e.tiendas.length - 1].idDB,
          co: tFound.idDB,
          presupuesto: (e.cargo.idDB == '070') ? e.totTienda.meta : e.totCat.meta,
          venta: (e.cargo.idDB == '070') ? e.totTienda.ventas : e.totCat.ventas,
          cumplimiento: (e.cargo.idDB == '070') ? e.totTienda.cumplimiento : e.totCat.cumplimiento,
          valorBruto: (e.cargo.idDB == '070') ? e.totTienda.valor : e.totCat.valor,
          valorNeto: (e.cargo.idDB == '070') ? e.totTienda.valorNeto : e.totCat.valorNeto,
          diasProg: e.totCat.diasProgramados,
          diasCom: e.totCat.diasCompensados,
          observaciones: (e.observaciones.length > 0) ? e.observaciones[0] : ''
        };
        data.push(de);
      }
    }


    this.exs.exportAsExcelFile(data, this.comision.nombre);
  }

  devolverInfoTienda(tiendaMaestraId: string, tiendas: any[]) {
    return tiendas.find(t => t.idDB = tiendaMaestraId);
  }

  devolverTiendaMayorVenta(ventas: any[], tiendas: any[]) {

    let _tiendas: any[] = [];

    tiendas.map(t => {
      let _f = _tiendas.find(_t => _t.idDB == t.idDB);
      if (!_f)
        _tiendas.push(t);
    });

    _tiendas.map(t => {
      let cantidad = ventas.filter(v => v.tienda == t.idDB).length;
      t.cantidad = cantidad;
    });

    return _tiendas.sort((a, b) => b.cantidad - a.cantidad)[0];
  }

  autorizarComisiones() {


    let consultas: any[] = [];
    for (let e of this.lstEmpleados) {
      if (e.estado.paraAprobacion == 0) {
        if (e.aprobado) {

          e.usuarioAprueba.push(this.usuarioAprueba);
          if (e.tempObs == '') {
            e.tempObs = 'aprobado';
            e.observaciones.push('Aprobado');
          } else
            e.observaciones.push(e.tempObs);

          e.fechaObs.push(moment().toISOString());

          consultas.push(this.cs.aprobarComision(e._id, this.usuarioAprueba, e.aprobado, e.observaciones, e.fechaObs));
        } else {

          if (e.tempObs == '') {
            alert(`Falta una observacion para el empleado ${e.empleado.nombre}`);
            return;
          } else if (e.tempValueCom == 0) {
            alert(`No se ha actuallizado el valor de la comision del colaborador ${e.empleado.nombre}`);
            return;
          } else {
            e.usuarioAprueba.push(this.usuarioAprueba);
            if (e.tempObs == '') {
              e.tempObs = 'aprobado';
              e.observaciones.push('Aprobado');
            } else
              e.observaciones.push(e.tempObs);

            e.fechaObs.push(moment().toISOString());

            consultas.push(this.cs.aprobarComision(e._id, this.usuarioAprueba, e.aprobado, e.observaciones, e.fechaObs));
          }
        }
      }
    }
    this.spinner.show();
    forkJoin(consultas).subscribe((d) => {
      this.spinner.hide();
      alert('Comisiones aprobadas');
    });
  }

  actualizarComEmpleado(e: any) {

    let emple = this.rows.find(r => r.codigo.id == e.empleado.id);

    if (emple.valor.cargo.idDB == '070') {
      emple.valor.totTienda.valorNeto = e.totCat.valorNeto;
    }

    if (emple) {
      emple.valor.totCat.valorNeto = e.totCat.valorNeto;
    }
  }

  recalcularComision(emple: EmpleadoComisionesModel) {
    // console.log(emple);
    emple.calcularComision(emple.ventas, emple.tiendas, this.comision.fechaInicio, this.comision.fechaFin);
  }

}

@Component({
  selector: 'apro-comision',
  templateUrl: '../templates/liquidar.comision.template.html'
})
export class LiquidarComisionesComponent implements OnInit {

  comision: ComisionModel;
  lstEmpleados: EmpleadoComisionesModel[] = [];
  tempListEmple: EmpleadoComisionesModel[] = [];
  oriLstEmpleados: EmpleadoComisionesModel[] = [];
  public fecha1: any;
  public fecha2: any;

  rows: any[] = [];
  tempRows: any[] = [];

  @ViewChild('myTable2', {static: true})
  table: any;

  columns = [
    {name: 'codigo'},
    {name: 'Tienda'},
    {name: 'Nombre'},
    {name: 'Cargo'},
    {name: 'Cantidad Mallas'},
    {name: 'Ventas'},
    {name: 'Meta'},
    {name: 'Cumplimiento'},
    {name: 'Dias'},
    {name: 'Valor'},
    {name: 'Para Liquidar'},
    {name: 'Observaciones'},
    {name: 'Liquidado'}
  ];

  listaPendientes: any[] = [];

  @Input()
  listaCargos: CargoEntity[] = [];

  totalDias: number = 0;

  userReg: UsuarioEntity[] = [];

  getRowClass = (row) => {
    // console.log(row);
    let diasInc = (row.dias.totCat.diasProgramados + row.dias.totCat.diasCompensados) !== this.totalDias;
    let retirado = (row.dias.empleado.estado && row.dias.empleado.estado == 'RETIRADO');


    if (retirado)
      diasInc = false;
    return {
      'diasInc': diasInc,
      'colReti': retirado
    };
  };


  constructor(private cs: ComisionServices, private activeRouter: ActivatedRoute, private spinner: NgxSpinnerService, private cargs: CargoServices, private us: UsuarioServices, private exs: ExcelServices) {
  }

  filtrarEmpleado(event) {
    let val = event.target.value.toLowerCase();
    const temp = this.tempRows.filter(e => {
      return e.nombre.toLowerCase().indexOf(val) !== -1 || !val;
    });

    this.rows = [...temp];
  }

  filtrarTienda(event) {
    let val = event.target.value.toLowerCase();
    const temp = this.tempRows.filter(e => {
      return e.tienda.toLowerCase().indexOf(val) !== -1 || !val;
    });

    this.rows = [...temp];
  }

  filtrarCedula(event) {
    let val = event.target.value.toLowerCase();
    const temp = this.tempRows.filter(e => {
      return e.empleado.doc.toLowerCase().indexOf(val) !== -1 || !val;
    });

    this.rows = [...temp];
  }

  ngOnInit(): void {

    let id = this.activeRouter.snapshot.params.id;


    this.spinner.show();

    this.cargs.getCargos().subscribe(d => {
      // console.log(d);
      this.listaCargos = d.data.cargos;
    });

    this.us.getAllUser().subscribe(d => {

      this.userReg = d.data.usuarios.filter((u) => {
        return u.rol.id == 5;
      });

      this.userReg.map((u) => {
        u.nombreCompleto = u.nombres + ' ' + u.apellidos;
      });

      for (let u of this.userReg) {
        this.us.getTiendasUsuario(u.id).subscribe(d => {
          u.tiendas = d.data.usuario.tiendas;

        });
      }
    });

    this.cs.getComision(id).subscribe((d: any) => {

      this.comision = d.data.comision;

      this.fecha1 = moment(this.comision.fechaInicio, 'YYYY-MM-DD');
      this.fecha2 = moment(this.comision.fechaFin, 'YYYY-MM-DD');

      this.totalDias = this.fecha2.diff(this.fecha1, 'd') + 1;

      this.cs.getEmpleadoComision(id, getLoginUser()).subscribe((d2: any) => {


        for (let de of d2.data.empleadoComision) {
          let nec: EmpleadoComisionesModel = new EmpleadoComisionesModel();
          nec.crearEmpleadoComisionModel(de);

          this.lstEmpleados.push(nec);
          this.oriLstEmpleados.push(nec);
          this.tempListEmple.push(nec);
        }

        this.ordenarLista();

        this.lstEmpleados.map((e) => {

          let tFound = e.tiendas.find(_t => _t.idDB == e.tiendaMaestra);

          // if(!tFound)
          //   tFound = this.devolverTiendaMayorVenta(e.ventas, e.tiendas);

          this.rows.push({
            codigo: e.empleado,
            tienda: (tFound) ? tFound.nombre : e.tiendas[e.tiendas.length - 1].nombre,
            nombre: e.empleado.nombre,
            cargo: e.cargo,
            cantidadMallas: e.mallas.length,
            ventas: e,
            meta: e,
            cumplimiento: e,
            valor: e,
            dias: e,
            aprobado: e,
            observaciones: e,
            liquidado: e,
            detalle: e
          });
        });

        this.rows = [...this.rows];
        this.tempRows = [...this.rows];

        this.spinner.hide();
        this.listaPendienteComisiones();
      });
    });
  }

  actualizarCambiosEmpleado(e: any) {

    let emple = this.rows.find(r => r.codigo.id == e.empleado.id);

    if (emple) {
      emple.cargo = e.cargo;
    }
  }

  actualizarCambioApro(e: any) {
    let emple = this.rows.find(r => r.codigo.id == e.empleado.id);

    let emple2 = this.tempRows.find(r => r.codigo.id == e.empleado.id);

    if (emple) {
      emple.detalle.aprobado = e.aprobado;
    }


    if (emple2) {
      emple2.detalle.aprobado = e.aprobado;
    }
  }

  exportarComision() {
    let data: any[] = [];

    for (let e of this.lstEmpleados) {
      // console.log(e);
      let tFound = e.tiendas.find(_t => _t.idDB == e.tiendaMaestra);
      if (e.mallas.length > 0) {
        let de = {
          id: e.empleado.doc.toString().trim(),
          nombre: e.empleado.nombre,
          cargo: e.cargo.nombre,
          tienda: (tFound) ? tFound.nombre : e.tiendas[e.tiendas.length - 1].nombre,
          co: e.tiendas[e.tiendas.length - 1].idDB,
          presupuesto: (e.cargo.idDB == '070') ? e.totTienda.meta : e.totCat.meta,
          venta: (e.cargo.idDB == '070') ? e.totTienda.ventas : e.totCat.ventas,
          cumplimiento: (e.cargo.idDB == '070') ? e.totTienda.cumplimiento : e.totCat.cumplimiento,
          valorBruto: (e.cargo.idDB == '070') ? e.totTienda.valor : e.totCat.valor,
          valorNeto: (e.cargo.idDB == '070') ? e.totTienda.valorNeto : e.totCat.valorNeto,
          diasProg: e.totCat.diasProgramados,
          diasCom: e.totCat.diasCompensados,
          aprobado: e.aprobado,
          observaciones: (e.observaciones.length > 0) ? e.observaciones[0] : ''
        };
        data.push(de);
      }
    }


    this.exs.exportAsExcelFile(data, this.comision.nombre);
  }

  onEmpleadoEliminado(emple: any) {
    // console.log(`eliminando comision ${emple._id}`);
    lodash.remove(this.rows, (e) => {
      return e.detalle._id == emple._id;
    });

    lodash.remove(this.tempRows, (e) => {
      return e.detalle._id == emple._id;
    });
  }

  ordenarLista() {
    this.lstEmpleados.sort((a, b) => {
      let tiendaA = a.tiendas[a.tiendas.length - 1];
      let tiendaB = b.tiendas[b.tiendas.length - 1];

      if (tiendaA.nombre > tiendaB.nombre)
        return 1;
      if (tiendaA.nombre < tiendaB.nombre)
        return -1;

      return 0;
    });
  }

  filtrarLista($event) {


    if ($event.target.checked) {
      const temp = this.tempRows.filter(e => {
        return !e.detalle.aprobado;
      });

      this.rows = [...temp];
      // this.lstEmpleados = this.oriLstEmpleados.filter(ce => {
      //   return !ce.aprobado;
      // });
    } else {
      // this.lstEmpleados = this.oriLstEmpleados;
      this.rows = [...this.tempRows];
    }
  }

  filtrarOtroCargos($event) {
    if ($event.target.checked) {
      const temp = this.tempRows.filter(e => {
        return (e.detalle.cargo.idDB == '000000');
      });

      this.rows = [...temp];

    } else {

      this.rows = [...this.tempRows];
    }

  }

  filtrarDuplicados($event) {
    if ($event.target.checked) {
      let dupli = [];
      let tempDupli = [];
      this.tempRows.map(e => {
        let find = tempDupli.find(td => {
          e.codigo == td.codigo;
        });
        if (find)
          dupli.push(e);
        else
          tempDupli.push(e);
      });

      this.rows = [...dupli];
    } else {
      this.rows = [...this.tempRows];
    }
  }

  filtrarRetirados($event) {
    if ($event.target.checked) {
      const temp = this.tempRows.filter(e => {
        return (e.detalle.empleado && e.detalle.empleado.estado == 'RETIRADO');
      });

      this.rows = [...temp];

    } else {

      this.rows = [...this.tempRows];
    }

  }

  filtrarListNoLiquidados($event) {

    if ($event.target.checked) {
      const temp = this.tempRows.filter(e => {
        return !e.detalle.paraAprobacion;
      });

      this.rows = [...temp];
      // this.lstEmpleados = this.oriLstEmpleados.filter(ce => {
      //   return !ce.aprobado;
      // });
    } else {
      // this.lstEmpleados = this.oriLstEmpleados;
      this.rows = [...this.tempRows];
    }
    // if ($event.target.checked) {
    //   this.lstEmpleados = this.oriLstEmpleados.filter(ce => {
    //     return ce.estado.paraAprobacion != 1;
    //   });
    // } else {
    //   this.lstEmpleados = this.oriLstEmpleados;
    // }
  }

  liquidarComision() {

    let consultas: any[] = [];

    for (let ce of this.oriLstEmpleados) {
      if (ce.estado.paraAprobacion == 1 && ce.aprobado) {
        consultas.push(this.cs.liquidarComision(ce._id, ce.totCat.valor, ce.observaciones, ce.usuarioAprueba, ce.fechaObs));
        ce.estado.liquidado = 1;
      } else {
        alert(`No se puede aprobar pre comision, falta por aprobar la comision de ${ce.empleado.nombre}`);
        return;
      }
    }

    this.spinner.show();

    forkJoin(consultas).subscribe((d) => {
      // console.log(d);
      alert('Comision pre liquidada');
      this.spinner.hide();
    });

  }

  devolverTotalComision() {
    let total = 0;

    for (let em of this.oriLstEmpleados) {
      total += +em.totCat.valorNeto;
    }

    return total;
  }

  listaPendienteComisiones() {
    let pendientes: any[] = [];

    for (let u of this.userReg) {

      let cantPendiente = 0;
      let fecha = '';
      for (let e of this.lstEmpleados) {

        let tFound = e.tiendas.find(t => t.idDB == e.tiendaMaestra);
        let tienda = (tFound) ? tFound : e.tiendas[e.tiendas.length - 1];


        let found = u.tiendas.find(t2 => t2.id == tienda.id);

        if (e.estado.paraAprobacion == 0) {
          if (found) {
            cantPendiente++;
          }
        } else {
          if (found)
            if (e.fechaAprobacion) {
              fecha = moment(e.fechaAprobacion).format('DD-MM-YYYY hh:mm');
            }
        }

      }

      pendientes.push({
        nombre: u.nombres + ' ' + u.apellidos,
        cantidad: cantPendiente,
        aprobacionEnviada: (cantPendiente > 0) ? 'No' : 'Si',
        fecha: (cantPendiente > 0) ? '' : fecha
      });
    }


    this.listaPendientes = pendientes;
  }

  toggleExpandRow(row) {
    // console.log(row);
    this.table.rowDetail.toggleExpandRow(row);
  }

}
